import Hero from "../components/Hero";
import GrowthStages from "../components/GrowthStages";
import Approach from "../components/Approach";
import Process from "../components/Process";
import Phygital from "../components/Phygital";
import Solutions from "../components/Solutions";
import Impact from "../components/Impact";
import WhyMedstry from "../components/WhyMedstry";
import About from "../components/About";
import QuizTeaser from "../components/QuizTeaser";
import LeadForm from "../components/LeadForm";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <GrowthStages />
      <Approach />
      <Process />
      <Phygital />
      <Solutions />
      <Impact />
      <WhyMedstry />
      <About />
      <QuizTeaser />
      <LeadForm />
    </main>
  );
}
